import axios from 'axios';
import { useState } from 'react';
import Button from '../../../components/inc/Button';
import Helper from '../../../inc/Helper';
import Settings from '../../../inc/Settings';
import DatepickerFunctions from '../../../inc/DatepickerHelper';
import TriggerOption from '../Trigger/TriggerOption';
import NavigationHeder from '../../../components/Navigations/NavigationHeder';
import AgGridNew from '../../../components/grid/ag/ag-grid-new'; 
import { connect } from 'react-redux';
import NewOverlayLoader from '../../../components/PurchaseRequisition/common/NewOverlayLoader';
import { statusLabelValueFormat } from '../../../components/grid/ag/commonFunctions/GridCommonFunctions';
import CreatedbyCustomCellRenderer from '../../../components/grid/ag/cellRender/CreatedbyCustomCellRenderer';
import Api from '../../../inc/Api';

let gridApi = null;
const WorkflowVersions = (props) => { 
  const [loading, setLoading] = useState(false); 
  const [isActive, setActive] = useState(false);
  const [triggerOptionModal, setTriggerOptionModal] = useState(false);
  const [workflowid, setWorkflowid] = useState('');
  const [templateid, setTemplateid] = useState(''); 

  if (localStorage.getItem("isWorkflow")) {
    localStorage.removeItem("isWorkflow")
  };

  const modalClose = () => {
    localStorage.removeItem("isWorkflowversion")
    localStorage.removeItem("templateId")
    localStorage.removeItem("isWorkflow")
    props.hideWorkflowVersions(false);
    props.setTemplateid(null);
  }

  const navigateToWorkflowBody = () => {
    if (!workflowid) {
      Helper.alert("Please select atleast one workflow", 'error');
      return;
    }
    setTriggerOptionModal(true);
    localStorage.setItem("templateId",props.templateId)
    localStorage.setItem("isWorkflowversion",true)
  }

  const onSelectionChanged = (event) => {
    let activeSelection = event.api.getSelectedRows();

    if (activeSelection?.length){
      setActive(activeSelection[0]?.active);
      setWorkflowid(activeSelection[0]?.workflow_id);
      setTemplateid(activeSelection[0]?.template_id); 
    } else { 
      setActive(false);
      setWorkflowid(null);
      setTemplateid(null);
    }
  };

  const workflowVersionActiveHandler = () => {
    if (!workflowid) {
      Helper.alert("Select a workflow for activate", 'error');
      return;
    }
    let formData;
    if (!isActive) {
      formData = {
        "workflow_id": workflowid,
        "active": true
      }
    } else {
      Helper.alert("Your workflow is already active");
      return;
    };

    setLoading(true);
    let api = Api;
    api.setUserToken()
    api.axios().post(Settings.baseUrl + `workflow/update`, formData).then((res) => {
      if (res.data.success) {
        Helper.alert(res.data.message);
        gridApi?.api?.refreshServerSide({ purge: true });
        gridApi?.api?.deselectAll();
        setLoading(false);
      };
    }).catch((error) => { 
      setLoading(false);
    })
  };

  const gridColsVersions = [
    { field: 'active', valueFormatter: (params) => params.value ? 'Active' : 'Inactive', headerName: Helper.getLabel(props.language,'1804004',"Status"),  filterParams: { values: [true, false], keyCreator: (params) => params.value, valueFormatter: (params) => params.value ? 'Active' : 'Inactive' }, cellRenderer: (params) => statusLabelValueFormat(params), filter: 'agSetColumnFilter' },
    { field: 'name', headerName: 'Name' },
    { field: 'version', headerName: 'Version' },
    { field: 'created_by', cellRenderer: CreatedbyCustomCellRenderer, headerName: 'Created by' },
    { field: 'created_at', valueFormatter: (params) => params.value ? DatepickerFunctions.convertDateTimeFromDataBase(params.value) : null, headerName:'Created date time', filter: 'agDateColumnFilter', editable: false }
  ];

  return (
    <>
      {loading ? <NewOverlayLoader /> : null }
      {triggerOptionModal ? <TriggerOption hideTriggerOption={setTriggerOptionModal} workflowid={workflowid} templateid={templateid} /> : ""}
      
      <NavigationHeder hideBackButton={false} title={`${'Workflow version'}`} modalClose={modalClose}>
        <Button title="Design" icon={'/images/icons/eye.svg'} onClick={navigateToWorkflowBody} />
        <Button title="Activate" isActive={true} onClick={workflowVersionActiveHandler} />
      </NavigationHeder>

      <AgGridNew
        apiUrl={Settings.baseUrl + `workflow/get-version`} 
        hideAddBtn={true}
        hideDeleteBtn={true}
        onSelectionChanged={onSelectionChanged} 
        rowType={'single'}
        gridId={'workflow_versions_grid'}
        columnDefs={gridColsVersions} 
        apiTokenRequired={false}
        onGridReady={ event => gridApi = event }
        height={500}
        btnsWrapperStyle="w-100"
        additionalParams={`?tenant_id=${props?.user?.tenant_id}&template_id=${props.templateId}`} // change this ? to & once pagination is true
        filterAdditionalParams={`?tenant_id=${props?.user?.tenant_id}&template_id=${props.templateId}`} // change this ? to & once pagination is true
        pagination={false}  
      />
    </>
  )
}

const mapStateToProps = (state) => {
  return { 
    user: state.auth.user
  }
};

export default connect(mapStateToProps) ((WorkflowVersions));